/**
 * levelMusic.ts
 * Maps a level id to its background music track.
 *
 * Only two tracks are committed today (see `src/assets/audio/music/`), so most
 * levels resolve to `null`. That is deliberate: silence is preferable to
 * playing Sunmeadow's theme over a world it was not written for.
 *
 * @module levelMusic
 */

import type { MusicId } from '../types/audio';

// DECISION: 1-4 gets Sunmeadow like the rest of World 1. It is a gauntlet, not
// a boss arena — World 1 has no boss (ROADMAP "World 1 has no boss", closed
// decision), so the Gale Rooster theme has nothing to score here. The Phase 3
// brief that calls 1-4 "The Gale Rooster's Arena" predates that decision.
// `boss-gale-rooster.m4a` therefore stays committed-but-unplayed, which is the
// state ADR-014 already records for the audio set.
const LEVEL_MUSIC: Readonly<Record<string, MusicId>> = {
  '1-0': 'world-1-sunmeadow',
  '1-1': 'world-1-sunmeadow',
  '1-2': 'world-1-sunmeadow',
  '1-3': 'world-1-sunmeadow',
  '1-4': 'world-1-sunmeadow',
};

/**
 * Resolve the music track for a level.
 *
 * @param levelId Canonical level id, e.g. `'1-2'` or `'3-B'`.
 * @returns The track to loop, or null when the level has no committed track.
 */
export function getMusicForLevel(levelId: string): MusicId | null {
  return Object.prototype.hasOwnProperty.call(LEVEL_MUSIC, levelId)
    ? (LEVEL_MUSIC[levelId] ?? null)
    : null;
}
